<template>
    <v-sheet color="transparent">
        <lecture-main-list-title v-bind="{ title, route }" />
        <v-row>
            <template v-for="value in items">
                <v-col cols="12" md="4" :key="value._id">
                    <lecture-list-card v-bind="{ value }" />
                </v-col>
            </template>
        </v-row>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_LIST_SORTS } from "@/assets/variables";

import LectureMainListTitle from "./lecture-main-list-title.vue";
import LectureListCard from "../list/lecture-list-card.vue";

const itemLength = 6;
const initHeaders = (headers = {}) => ({
    ...headers,
    sort: headers?.sort || RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.sort,
    limit: headers?.limit || itemLength * 2,
});

export default {
    components: {
        LectureMainListTitle,
        LectureListCard,
    },
    props: {
        title: { type: String, default: "전체" },
        route: { type: [String, Object], default: () => ({ path: "/lectures", query: { category: null } }) },

        params: { type: Object, default: () => ({}) },
        headers: { type: Object, default: initHeaders },
    },
    data: () => ({
        lectures: [],

        loading: false,
    }),
    computed: {
        items() {
            const shuffled = this.lectures.sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, this.headers.limit / 2);
            return selected;
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        headers() {
            this.search();
        },
        params() {
            this.search();
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { headers, params } = this;
                const { lectures = [] } = await api.v1.lectures.gets({ headers, params });
                this.lectures = lectures;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
